import type * as Types from '../../../../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IsSpecialistQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type IsSpecialistQuery = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly parentUser?: { readonly __typename?: 'AccountsParentUser', readonly id: string } | null } | null };


export const IsSpecialistDocument = gql`
    query IsSpecialist {
  currentUser {
    parentUser {
      id
    }
  }
}
    `;

/**
 * __useIsSpecialistQuery__
 *
 * To run a query within a React component, call `useIsSpecialistQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsSpecialistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsSpecialistQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsSpecialistQuery(baseOptions?: Apollo.QueryHookOptions<IsSpecialistQuery, IsSpecialistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsSpecialistQuery, IsSpecialistQueryVariables>(IsSpecialistDocument, options);
      }
export function useIsSpecialistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsSpecialistQuery, IsSpecialistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsSpecialistQuery, IsSpecialistQueryVariables>(IsSpecialistDocument, options);
        }
export function useIsSpecialistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsSpecialistQuery, IsSpecialistQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsSpecialistQuery, IsSpecialistQueryVariables>(IsSpecialistDocument, options);
        }
export type IsSpecialistQueryHookResult = ReturnType<typeof useIsSpecialistQuery>;
export type IsSpecialistLazyQueryHookResult = ReturnType<typeof useIsSpecialistLazyQuery>;
export type IsSpecialistSuspenseQueryHookResult = ReturnType<typeof useIsSpecialistSuspenseQuery>;
export type IsSpecialistQueryResult = Apollo.QueryResult<IsSpecialistQuery, IsSpecialistQueryVariables>;